import React from 'react';

function Placeholder() {
  return (
    <div className="Placeholder">
      <h1>
        Under Construction
        <br />
        Coming Soon
      </h1>
    </div>
  );
}

export default Placeholder;
